import { useGo, useNotification, OpenNotificationParams } from '@refinedev/core';
import { useMutation } from '@tanstack/react-query';
import { SmartAuthProvider } from '../../../../../App';
import { useState } from 'react';
import { useBetween } from 'use-between';
import { IUserDetails, USER_DETAILS_KEY } from '../../../../providers/authProvider';

const buildNotification = (error?: Error | any): OpenNotificationParams => {
  return {
    message: error?.name || 'Error verifying email',
    description: error?.message || 'Error while resend email',
    key: 'resend-email-error',
    type: 'error',
  };
};

export function useResendVerifyEmail() {
  const { close, open } = useNotification();
  const { resendVerifyEmail } = SmartAuthProvider;
  const go = useGo();

  const mutation = useMutation(
    ['useResendVerifyEmail'],
    resendVerifyEmail,
    {
      onSuccess: ({ success, redirectTo, error }) => {
        if (success) {
          close?.('forgot-password-error');
        }

        if (error || !success) {
          open?.(buildNotification(error));
        }

        if (redirectTo) {
          go({ to: redirectTo, type: 'replace' });
        }
      },
      onError: (error: any) => {
        open?.(buildNotification(error));
      },
    },
  );

  return mutation;
}

// TODO: replace to react context alternative: https://github.com/Polecat/smart-web/pull/13#discussion_r1180409597
const useEmail = () => {
  const [email, saveEmail] = useState('');
  return { email, saveEmail };
};

export const useSharedEmail = () => useBetween(useEmail);

export const useUserDetails = (): Partial<IUserDetails> => {
  return JSON.parse(localStorage.getItem(USER_DETAILS_KEY) ?? '{}');
};
